export default function AddressCta() {
  const ping = () => {
    const b = document.querySelector("#cta-ping");
    if (b) {
      b.classList.remove("cta-pop");
      void (b as HTMLElement).offsetWidth;
      b.classList.add("cta-pop");
    }
  };

  return (
    <section className="py-12 md:py-16">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-primary-600 via-primary-500 to-accent-500 px-6 py-12 text-center md:px-12 md:py-16">
          <div className="pointer-events-none absolute -left-16 -top-16 h-52 w-52 rounded-full bg-background-50/10 blur-2xl"></div>
          <div className="pointer-events-none absolute -bottom-20 -right-10 h-56 w-56 rounded-full bg-accent-200/20 blur-2xl"></div>

          <p className="mx-auto inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-xs font-semibold text-background-50 backdrop-blur">
            <i className="ri-road-map-line text-sm leading-none"></i>
            吃瓜网址换地址了 · 认准本页
          </p>
          <h2 className="mx-auto mt-5 max-w-2xl font-heading text-2xl font-black leading-tight text-background-50 md:text-4xl">
            别让一条旧链接，断了今晚的瓜。
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-sm leading-7 text-primary-50/90 md:text-base">
            吃瓜网址新地址已上线。收藏本页、跟上更新通知，换址也能第一时间回到最新入口，热榜专题照看不误。
          </p>

          <div className="mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <button
              onClick={ping}
              className="inline-flex items-center justify-center whitespace-nowrap rounded-full bg-background-50 px-6 py-3 text-sm font-bold text-primary-700 transition-transform hover:scale-[1.03]"
            >
              <i className="ri-bookmark-fill mr-2 text-base leading-none"></i>
              收藏本页新地址
            </button>
            <button
              onClick={ping}
              className="inline-flex items-center justify-center whitespace-nowrap rounded-full border border-background-50/60 bg-background-50/10 px-6 py-3 text-sm font-semibold text-background-50 backdrop-blur transition-colors hover:bg-background-50/20"
            >
              <i className="ri-notification-3-fill mr-2 text-base leading-none"></i>
              订阅更新通知
            </button>
          </div>

          <p id="cta-ping" className="mt-5 text-xs text-primary-100/80">
            演示站点的静态提示，点击即返回成功状态（未接接口）。
          </p>
        </div>
      </div>
    </section>
  );
}